import { TaskPropertyButton } from './task-property.button';
import { format } from 'date-fns';
import { dateShort } from '../../../assets/contants/dates-fns';
import { CalendarIcon } from '@radix-ui/react-icons';
import React from 'react';
import { openModal } from '../../../core/modal/open-modal';
import { DateSelectionModal } from '../../process/components/date-selection.modal';

interface CreateTaskDatePropertyProps {
  value?: Date | string;
  onChange: (value: string) => void;
}

export const CreateTaskDateProperty: React.FC<CreateTaskDatePropertyProps> = ({
  value,
  onChange,
}) => {
  const openEditModal = () => {
    openModal(DateSelectionModal, {
      fieldName: 'dueDate',
      value: value ? format(new Date(value), dateShort) : new Date(),
      onSubmit: onChange,
    });
  };

  return (
    <TaskPropertyButton
      icon={<CalendarIcon />}
      label={value ? format(new Date(value), dateShort) : 'Set due date'}
      onClick={openEditModal}
      isActive={!!value}
    />
  );
};
